import EmployeeAdapter from './employee.adapter';
import DoctorAdapter from './doctor.adapter';

export const employeeAdapter = EmployeeAdapter;
export const doctorAdapter = DoctorAdapter;
